import React, { useMemo } from "react";
import { Box } from "@mui/material";

interface TabNameProps {
  isLoading: boolean;
  currentCount: number | undefined;
  totalCount: number | undefined;
  label: string;
}

const TabName: React.FC<TabNameProps> = ({
  isLoading,
  currentCount,
  totalCount,
  label,
}) => {
  const tabContent = useMemo(() => {
    return (
      <Box>
        {label}{" "}
        <span className="value">
          {isLoading ? "Loading..." : currentCount || 0} ({totalCount || 0})
        </span>
      </Box>
    );
  }, [isLoading, currentCount, totalCount, label]);

  return tabContent;
};

export default React.memo(TabName);
